export default {
  RESET_STATE: 'surveys/reset_state',

  GET_SURVEY_REQUEST: 'surveys/get_survey/request',
  GET_SURVEY_SUCCESS: 'surveys/get_survey/success',
  GET_SURVEY_FAILURE: 'surveys/get_survey/fail',
}
